$(document).on("turbolinks:load", () => {
    var new_item_1 = $("#new_item_1");
    var new_item_2 = $("#new_item_2");
    var new_item_3 = $("#new_item_3");
    var new_item_4 = $("#new_item_4");
    var new_item_5 = $("#new_item_5");
    var new_item_6 = $("#new_item_6");
    var new_item_7 = $("#new_item_7");
    var new_item_8 = $("#new_item_8");
    var new_item_9 = $("#new_item_9");
    $("#show_more_line_button").click(function(e){
        if(new_item_1.is(":hidden")) {
            new_item_1.slideDown();
            $("#enable_new_item_1").prop("checked", true);
        } else if(new_item_2.is(":hidden")) {
            new_item_2.slideDown();
            $("#enable_new_item_2").prop("checked", true);
        } else if(new_item_3.is(":hidden")) {
            new_item_3.slideDown();
            $("#enable_new_item_3").prop("checked", true);
        } else if(new_item_4.is(":hidden")) {
            new_item_4.slideDown();
            $("#enable_new_item_4").prop("checked", true);
        } else if(new_item_5.is(":hidden")) {
            new_item_5.slideDown();
            $("#enable_new_item_5").prop("checked", true);
        } else if(new_item_6.is(":hidden")) {
            new_item_6.slideDown();
            $("#enable_new_item_6").prop("checked", true);
        } else if(new_item_7.is(":hidden")) {
            new_item_7.slideDown();
            $("#enable_new_item_7").prop("checked", true);
        } else if(new_item_8.is(":hidden")) {
            new_item_8.slideDown();
            $("#enable_new_item_8").prop("checked", true);
        } else if(new_item_9.is(":hidden")) {
            new_item_9.slideDown();
            $("#enable_new_item_9").prop("checked", true);
            $("#show_more_line_button").slideUp();
        }
    });
});